import { SimulationModal } from "@/services/project/simulation.service"
import { ProjectManagementMenu } from "../menus/ProjectManagementMenu"
import { TemplateMenu } from "../menus/TemplateMenu"
import { Simulation } from "./Simulation/Simulation"
import styles from './styles.module.less'
import { ReactState } from "../../hooks/useReactState"
import { Dropdown, Space } from "antd"
import { MenuOutlined, PrinterOutlined, SaveOutlined } from "@ant-design/icons"
import { useContext } from "react"
import { FlowsheetContext } from "../../FlowsheetProvider"
import { OPermission } from "@/components/OPermission/OPermission"
import { ROLE_CHEMENG, ROLE_DRAFTER } from "@/components/OPermission/PlanPermission"

interface FlowHeaderProps {
  isTemplate: boolean
  sim?: SimulationModal | null
  panelState: ReactState
}
export const FlowHeader = (props: FlowHeaderProps) => {
  const {isTemplate, sim, panelState} = props;
  const {save, print} = useContext(FlowsheetContext)
  return <div className={styles.header}>
    <Space className="ml-2">
      <OPermission permissions={ROLE_DRAFTER}><SaveOutlined style={{fontSize: 28, cursor: 'pointer'}} onClick={save} /></OPermission>
      <PrinterOutlined style={{fontSize: 28, cursor: 'pointer'}} onClick={print} />
      <OPermission permissions={ROLE_CHEMENG}>
        <ProjectManagementMenu sim={sim} />
      </OPermission>
      
      {isTemplate && <TemplateMenu />}
    </Space>
    <OPermission permissions={ROLE_CHEMENG}>
      {!isTemplate && <div>
        <Simulation panelState={panelState} />
      </div>}
    </OPermission>
    
  </div>
}